export default {
      id: "icon-linkedin-widget-usage",
      viewBox: "0 0 27 29",
      url: __webpack_public_path__ + "icons.svg#icon-linkedin-widget",
      toString: function () {
        return this.url;
      }
    }